(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["KdUi"] = factory(require("React"), require("ReactDOM"));
	else
		root["KdUi"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_123__, __WEBPACK_EXTERNAL_MODULE_174__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition